import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { NavigationHistoryService } from '../../../../_shared/services/navigation-history.service';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive, NgbTooltipModule, TranslocoDirective],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent {
  @Input() isCollapseSidebar: boolean = false;
  @Input() isCompact: boolean = false;
  @Input() closeSidebar!: () => void;
  @Output() toggleCollapse = new EventEmitter<void>();

  private readonly router = inject(Router);
  private readonly navigationHistory = inject(NavigationHistoryService);

  btnCollapseProps(): void {
    this.toggleCollapse.emit();
  }

  goToSettings(event: Event): void {
    event.preventDefault();
    this.navigationHistory.setBackButtonVisible(true);
    this.router.navigate(['/settings']);
  }
}